import { createContext, useContext } from "react";

export const SiteContext = createContext({
  openDiagnostic: () => {},
  openTalk: () => {},
});

export const useSite = () => useContext(SiteContext);
